var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15368_1410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.25 0 0 2.25 0 5C0 7.75 2.25 10 5 10C7.75 10 10 7.75 10 5C10 2.25 7.75 0 5 0ZM6.98875 6.105C7.11063 6.22687 7.11063 6.425 6.98875 6.54688L6.54688 6.98875C6.425 7.11063 6.22687 7.11063 6.105 6.98875L5 5.88375L3.895 6.98875C3.77312 7.11063 3.575 7.11063 3.45312 6.98875L3.01125 6.54688C2.88937 6.425 2.88937 6.22687 3.01125 6.105L4.11625 5L3.01125 3.895C2.88937 3.77312 2.88937 3.575 3.01125 3.45312L3.45312 3.01125C3.575 2.88937 3.77312 2.88937 3.895 3.01125L5 4.11625L6.105 3.01125C6.22687 2.88937 6.425 2.88937 6.54688 3.01125L6.98875 3.45312C7.11063 3.575 7.11063 3.77312 6.98875 3.895L5.88375 5L6.98875 6.105Z",
    fill: "#D01A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15368_1410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel_Icon.f48f6dfdacbe1bd835a5c943389ec7c5.svg";
export { ForwardRef as ReactComponent };